import type { MetadataFormat } from '@/data/Metadata';
import Metadata from '@/data/Metadata';

export default class MetadataParser {
  static fromFormat(
    format: MetadataFormat,
  ): Metadata {
    const refs: Record<string, string> = {};

    Object.keys(format).forEach((k) => {
      if (k.substring(0, 3) === 'ref') {
        refs[k.substring(4)] = String((format as unknown as Record<string, string>)[k]);
      }
    });

    return new Metadata({
      contributors: format.contributors,
      album: format.album,
      year: format.year,
      refs,
      license: format.license,
      text: format.text ?? format.info,
    });
  }
}
